module.exports = __webpack_public_path__ + "/images/lato-v16-latin-100.svg";